<div class="panel-body ">
  <div class="col-md-12 panel panel-default panel-margin-bottom panel-margin-top">
  <div class="panel-body">
  <div class="row ">
    <div class="col-md-6 panel panel-default ">
      <div class="panel panel-default ">
        <div id="V017b" class="panel-title ">
          <span class="field-code ">V017a V003a json='civilCase.caseNumber.county','civilCase.caseNumber.fileNumber'</span>
          Case County and Number
        </div>
        <div class="panel-body " id="civil-caseDetails-caseInformation-caseNumber">
         {{civilCase.getCaseCounty()}} {{civilCase.getCaseNumber()}}
         <div id="V001-FromAppeal" *ngIf="civilCase.getFromAppealedCaseNumber() !== '-'" >
            <span class="field-code ">V001-FromAppeal</span>
            {{civilCase.getFromAppealedCaseNumber()}}
         </div>
         <div id="V001-ToAppeal" *ngIf="civilCase.getToAppealedCaseNumber() !== '-'" >
            <span class="field-code ">V001-ToAppeal</span>
            {{civilCase.getToAppealedCaseNumber()}}
         </div>  
         <div id="V001-TransferAppealandNotice" *ngIf="civilCase.getTransferAndAppealsNotice() !== '-'" >
            <span class="field-code ">V001-TransferAppealandNotice</span>
            {{civilCase.getTransferAndAppealsNotice()}}
         </div>       
        </div>
      </div>
      <div class="panel panel-default ">
        <div id="V515" class="panel-title ">
          <span class="field-code ">V515 json='civilCase.caseNumber.fileNumber'</span>
          Case Type
        </div>
        <div class="panel-body " id="civil-caseDetails-caseInformation-caseType">
         {{civilCase.getCourtTypeName(civilCase.getCaseNumber())}}
        </div>
      </div>      
      <div class="panel panel-default ">
        <div id="V085b" class="panel-title ">
          <span class="field-code ">V085a json='caseCaption'</span>Caption
        </div>
        <div class="panel-body " id="civil-caseDetails-caseInformation-caseCaption">
          {{civilCase.getCaseCaption()}}
        </div>
      </div>
      <div *ngIf="civilCase.getDomesticCaseType() !== '-'" class="panel panel-default ">
        <div id="V082" class="panel-title ">
          <span class="field-code ">V082 json='civilCase.domesticType.description'</span>Domestic Case Type
        </div>
        <div class="panel-body " id="civil-caseDetails-caseInformation-domesticCaseType">
          {{civilCase.getDomesticCaseType()}}
        </div>
      </div>
      <div class="panel panel-default ">
        <div id="V072" class="panel-title ">
          <span class="field-code ">V072 json='caseEventList.clockDate'</span>Case Initiation Clock Date
        </div>
        <div class="panel-body " id="civil-caseDetails-caseInformation-clockDateByCaseEventCode">
          {{civilCase.getClockDateByCaseEventCode('INIT') | date:'MM/dd/yyyy'}}
        </div>
      </div>
      <div *ngIf="civilCase.getDisposedOn() !== ''" class="panel panel-default ">
        <div id="V074" class="panel-title ">
          <span class="field-code ">V074 json='civilCase.dispositionClockDate'</span>Disposed on
        </div>
        <div class="panel-body " id="civil-caseDetails-caseInformation-disposedOn">
          {{civilCase.getDisposedOn() | date:'MM/dd/yyyy'}}
        </div>
      </div>
      <div *ngIf="civilCase.getPresidingOfficialName() !== '-' || civilCase.getPresidingOfficialNumber() !== '-'" class="panel panel-default ">
        <div id="X040" class="panel-title ">
          Presiding Official
        </div>
        <div class="panel-body ">
          <dl class="dl-vertical ">
            <dt id="V040" class="summary-label ">
              <span class="field-code ">V040 json='civilCase.presidingOfficialName'</span>Name
            </dt>
            <dd id="civil-caseDetails-caseInformation-presidingOfficialNamee">
              {{civilCase.getPresidingOfficialName()}}
            </dd>
            <dt id="V084" class="summary-label ">
              <span class="field-code ">V084 json='civilCase.presidingOfficialNumber'</span>ID Number
            </dt>
            <dd id="civil-caseDetails-caseInformation-presidingOfficialNumber">
              {{civilCase.getPresidingOfficialNumber()}}
            </dd>
          </dl>
        </div>
      </div>

      <div *ngIf="civilCase.getJuryTrialWasRequested() !== '-' && civilCase.showJuryTrialWasRequestedField() === true" class="panel panel-default ">
        <div id="V073" class="panel-title ">
          <span class="field-code ">V073 json='caseEventList.caseEvent.code'</span>Jury Trial Was Requested
        </div>
        <div class="panel-body " id="{{'civil-caseDetails-caseInformation-juryTrialWasRequested'}}">
          {{civilCase.getJuryTrialWasRequested()}}
        </div>
      </div>
    </div>
    <div class="col-sm-6 panel panel-default ">
      <div *ngIf="civilCase.getEligibleforMediatedSettlementConference() !== '-'" class="panel panel-default ">
        <div id="V076" class="panel-title ">
          <span class="field-code ">V076 json='caseEventList.caseEvent.code'</span>Eligible for Mediated Settlement Conference
        </div>
        <div class="panel-body " id="civil-caseDetails-caseInformation-eligibleforMediatedSettlementConference">
          {{civilCase.getEligibleforMediatedSettlementConference()}}
        </div>
      </div>
      <div *ngIf="civilCase.getEligibleForCustodyVisitationMediation() !== '-'" class="panel panel-default ">
        <div id="V077" class="panel-title ">
          <span class="field-code ">V077 json='caseEventList.caseEvent.code'</span>Eligible for Custody/Visitation Mediation
        </div>
        <div class="panel-body " id="civil-caseDetails-caseInformation-eligibleForCustodyVisitationMediation">
          {{civilCase.getEligibleForCustodyVisitationMediation()}}
        </div>
      </div>
      <div *ngIf="civilCase.getEligibleForArbitration() !== '-'" class="panel panel-default ">
        <div id="V078" class="panel-title ">
          <span class="field-code ">V078 json='caseEventList.caseEvent.code'</span>Eligible for Arbitration
        </div>
        <div class="panel-body " id="civil-caseDetails-caseInformation-eligibleForArbitration">
          {{civilCase.getEligibleForArbitration()}}
        </div>
      </div>
      <div *ngIf="civilCase.getInterpreterNeeded() !== '-' || civilCase.getInterpreterUsed() !== '-'" class="panel panel-default ">
        <div id="X086" class="panel-title ">
          Interpreter
        </div>
        <div class="panel-body ">
          <dl class="dl-vertical ">
            <dt id="V086"  class="summary-label ">
              <span class="field-code ">V086 json='interpreterLanguage'</span>Needed
            </dt>
            <dd id="civil-caseDetails-caseInformation-interpreterNeeded">
              {{civilCase.getInterpreterNeeded()}}
            </dd>
            <dt id="V087" class="summary-label ">
              <span class="field-code ">V087 json='interpreterUsed'</span>Used
            </dt>
            <dd id="civil-caseDetails-caseInformation-interpreterUsed">
              {{civilCase.getInterpreterUsed()}}
            </dd>
          </dl>
        </div>
      </div>
      <div *ngIf="civilCase.getCourtSessionDate() !== ''" class="panel panel-default ">
        <div id="X079" class="panel-title ">
          Court Calendar Event 
        </div>
        <div class="panel-body ">
          <dl class="dl-vertical ">
            <dt id="V079" class="summary-label ">
              <span class="field-code ">V079 json='caseCalendar.beginDate'</span>Date
            </dt>
            <dd>
            <div *ngIf="civilCase.getCourtSessionDate() !== ''" id="civil-caseDetails-caseInformation-courtSessionDate">              
            {{civilCase.getCourtSessionDate() | date:'MM/dd/yyyy'}}
            </div>
            </dd>
            <dt id="V080" class="summary-label ">
              <span class="field-code ">V080 json='caseCalendar.trialTime'</span>Time
            </dt>
            <dd id="civil-caseDetails-caseInformation-courtSessionTime">
              {{civilCase.getCourtSessionTime()}}
            </dd>
            <dt id="V038" class="summary-label ">
              <span class="field-code ">V038 json='caseCalendar.description'</span>Room
            </dt>
            <dd id="civil-caseDetails-caseInformation-courtSessionRoom">
              {{civilCase.getCourtSessionRoomCode()}} {{civilCase.getCourtSessionRoomDescription()}}
            </dd>
            <div *ngIf="civilCase.getCourtSessionNotes() !== '-'">
              <dt id="V081" class="summary-label ">
                <span class="field-code ">V081 json='caseCalendar.note'</span>Notes</dt>
              <dd id="civil-caseDetails-caseInformation-courtSessionNotes">
                {{civilCase.getCourtSessionNotes()}}
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
  </div>

  <div class="row " *ngIf="civilCase.getConsolidatedCaseList().length !== 0">
    <div class="col-md-12 panel panel-default ">
      <div id="X210" class="panel-title ">
        Consolidated Cases
      </div>
      <div class="panel-body ">
        <div class="table-responsive">
          <table id="consolidatedCases-table" class="table table-condensed table-striped ">
            <thead>
              <tr>
                <th id="V210">
                  <span class="field-code">V210 json='dispositionClockDate'</span>
                  Consolidation Order Clock Date
                </th>
                <th id="V017c">
                  <span class="field-code">V017c V083 json='caseNumber.county','caseNumber.fileNumber','civilCase.leadConsolidatedCase.rowKey'</span>
                  Consolidated Case
                </th>
                <th id="V085c">
                  <span class="field-code">V085c json='consolidatedCaseList.caseCaption or leadConsolidatedCase.caseCaption or caseCaption'</span>
                  Caption
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let consolidatedCase of civilCase.getConsolidatedCaseList(); let cc = index">
                <td *ngIf="civilCase.getConsolidationOrderClockDate(consolidatedCase) !== '' && civilCase.getConsolidatedCaseLeadIndicator(consolidatedCase) === ''" id="{{'civil-caseDetails-caseInformation-'+cc+'-consolidationOrderClockDate'}}">
                  {{civilCase.getConsolidationOrderClockDate(consolidatedCase) | date:'MM/dd/yyyy'}}
                </td>
                <td *ngIf="civilCase.getConsolidationOrderClockDate(consolidatedCase) === '' && civilCase.getConsolidatedCaseLeadIndicator(consolidatedCase) === ''" id="{{'civil-caseDetails-caseInformation-'+cc+'-consolidationOrderClockDate'}}">
                  -
                </td>
                <td *ngIf="civilCase.getConsolidatedCaseLeadIndicator(consolidatedCase) !== ''" id="{{'civil-caseDetails-caseInformation-'+cc+'-consolidationOrderClockDate'}}">
                  {{civilCase.getConsolidatedCaseLeadIndicator(consolidatedCase)}}
                </td>                 
                <td id="{{'civil-caseDetails-caseInformation-'+cc+'-consolidationCounty'}}">
                  {{civilCase.getConsolidationCounty(consolidatedCase)}} {{civilCase.getConsolidationCaseNumber(consolidatedCase)}}
                </td>
                <td id="{{'civil-caseDetails-caseInformation-'+cc+'-consolidationCaseCaption'}}">
                  {{civilCase.getConsolidationCaseCaption(consolidatedCase)}}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <div class="row " *ngIf="civilCase.getMicroFilmList().length !== 0">
    <div class="col-md-12 panel panel-default ">
      <div id="V467" class="panel-title ">
        <span  class="field-code ">V467 json='json.filmYear','json.filmReel''json.filmFrame'</span>
        Archival Scan Numbers
      </div>
      <div class="panel-body " *ngIf="civilCase.getMicroFilmList().length > 0">
         <ul class="four-column">
            <li *ngFor="let microfilm of civilCase.getMicroFilmList(); let i = index" id="{{'civil-caseDetails-caseInformation-digitalScanMicrofilm-' + i + '-locationNumbers'}}">
                  {{civilCase.getDigitalScanMicrofilmLocationNumbers(microfilm).trim()}}
            </li>
         </ul>
      </div>
    </div>
  </div>
  </div>
</div>
  


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/civil/civil-case-information/civil-case-information.component.html